export const shouldISendCmsKeyMissingError = (keyAsArray: string[]): boolean => {
  return !(keyAsArray[0] === '' || keyAsArray.includes('fragments'));
};

/**
 * Error thrown when a CMS translation key is missing. Carries the key so monitoring can both show it
 * in the message and pass it as a custom Datadog fingerprint — giving each distinct key its own issue
 * in Error Tracking (instead of everything collapsing into one masked `CMS missing key: *.*.*` issue).
 */
export class CmsMissingKeyError extends Error {
  constructor(readonly cmsKey: string) {
    super(`CMS missing key: ${cmsKey}`);
    this.name = 'CmsMissingKeyError';
  }
}
